import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import './firebase/config'
import { useAuthStore } from './stores/auth'
import { useThemeStore } from './stores/theme'
import { initPwaUpdate } from './composables/usePwaUpdate'

// CSS
import './assets/main.css'
import 'vue-toastification/dist/index.css'

// PWA: register early, detect new deployments, show Update Available banner in App.vue
initPwaUpdate()

const app = createApp(App)

// Vuetify
app.use(vuetify)

// Pinia store — no global loading overlay (page-local loaders only;
// attendance keeps its own location refresh spinner)
const pinia = createPinia()
app.use(pinia)

// Initialize stores before mounting
const authStore = useAuthStore()
const themeStore = useThemeStore()

// Initialize theme system immediately
themeStore.initializeTheme()
authStore.initAuth()

// Router
app.use(router)

// Toast notifications
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  // iOS Safari can lock touch interactions with draggable toasts.
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
})

app.mount('#app')
